import { useChat } from '@/components/chat/useChat'
import ChatIcon from '@/components/icons/chat'
import { IconButton } from '@/components/ui/icon-button'

export default function HeaderChatTrigger() {
  const [isOpen, onToggle] = useChat((state) => [state.isOpen, state.onToggle])

  return (
    <IconButton
      variant='outline'
      size='lg'
      // remover propriedades CSS depois da
      // padronização dos estilos de design
      // com o novo design system
      bgColor='transparent'
      color='#E6E3E8'
      _before={{
        content: '""',
        backgroundImage:
          'radial-gradient(circle at center, rgba(241, 221, 249, 0.1) 5%, transparent 60%)',
        opacity: 0,
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '-1px',
        transition: 'opacity 200ms ease',
        h: '1px',
        w: 'full',
      }}
      _hover={{
        borderColor: '#271C2B',
        bgColor: '#201523',
        bgImage:
          'radial-gradient(50.92% 50% at 50% 100%, rgba(159, 131, 173, 0.10) 0%, rgba(0, 0, 0, 0.00) 100%)',
        _before: {
          opacity: 1,
        },
      }}
      // -----------------------------
      aria-label='Open chat'
      onClick={onToggle}
      {...(isOpen && {
        bgImage:
          'radial-gradient(50.92% 50% at 50% 100%, rgba(255, 255, 255, 0.60) 0%, rgba(117, 70, 96, 0.00) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.04) 100%), linear-gradient(125deg, #E90083 0%, #FF6864 100%)!',
        color: 'white!',
      })}
    >
      <ChatIcon size='sm' />
    </IconButton>
  )
}
